import { CommandType } from "~app/common/services/cqs/CommandType";
import { ArbetsorderAtgardBaseCommand } from "./ArbetsorderAtgardBaseCommand";

export class AttachAtgardToArbetsorderCommand extends ArbetsorderAtgardBaseCommand {
    atgardGuid: string;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type  = "AttachAtgardToArbetsorderCommand";

    constructor(arbetsorderId: number, atgardGuid: string) {
        super(AttachAtgardToArbetsorderCommand.$type, CommandType.Insert);
        this.atgardGuid = atgardGuid;
        this.arbetsorderId = arbetsorderId;
    }
}
